module.exports = __webpack_public_path__ + "ed4c7c35095339e114694726c888bb4c.pdf";